class QuickStartModuleInstruction implements Interfaces.IQuickStartModuleCounter {
    QuickStartModuleCounterMessageBusEventName: string = "notifyUserOnInstructionChange";
    QuickStartModuleCounterGetValueUrl: string = "InstructionBook/GetInstructionCountByUserId";
}
export default QuickStartModuleInstruction;